import React from "react";
import { Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import './signResponse.css';

const ContractSignSuccess = () => {
    const { t } = useTranslation();
    return (
        <div className='bl-back-image'>
            <Row>
                <Col xl="12" lg="12" md="12" sm="12" xm="12" style={{marginTop: '10%'}}>
                    <div>
                        <h1 className="text-center text-success text-congrats">
                            {t("userDataForm.signRedirectPages.signSuccess.title")}
                        </h1>

                        <div className="text-center text-white pl-2 pr-2" style={{fontSize: '20px', marginTop: '40px'}}>
                            <p>
                                {t("userDataForm.signRedirectPages.signSuccess.description")}
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default ContractSignSuccess;